import { render, staticRenderFns } from "./AddContentTypeComponent.vue?vue&type=template&id=63635832&scoped=true"
import script from "./AddContentTypeComponent.vue?vue&type=script&lang=js"
export * from "./AddContentTypeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63635832",
  null
  
)

export default component.exports